"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import R from "ramda";
import AnnotationSurface from "./annotation_surface";
import { connect } from "react-redux";
import {
  canvasMouseDown,
  canvasMouseUp,
  canvasMouseMove,
  canvasSizeUpdated,
  loadAnnotations,
  updateAnnotations,
  deleteAnnotation
} from "../redux/actions";
const AnnotationCanvas = (props) => {
  return /* @__PURE__ */ React.createElement(
    AnnotationSurface,
    __spreadValues({}, props)
  );
};
AnnotationCanvas.propTypes = {
  width: React.PropTypes.number.isRequired,
  height: React.PropTypes.number.isRequired,
  annotating: React.PropTypes.bool.isRequired,
  cropping: React.PropTypes.bool.isRequired
};
AnnotationCanvas.contextTypes = {
  store: React.PropTypes.shape({
    getState: React.PropTypes.func.isRequired,
    dispatch: React.PropTypes.func.isRequired
  }).isRequired
};
const connectedAnnotationCanvas = connect(
  (state) => {
    return {
      annotationComponents: R.values(state.views),
      editedTextAnnotation: state.textEditingMode,
      hover: state.hover,
      selected: state.selected,
      loading: state.annotationMode.loading
    };
  },
  (dispatch) => {
    return {
      handlers: {
        loadAnnotations: (page) => dispatch(loadAnnotations(page)),
        updateAnnotations: (page) => dispatch(updateAnnotations(page)),
        deleteAnnotation: (id) => dispatch(deleteAnnotation(id)),
        canvas: {
          onMouseDown: (coords) => dispatch(canvasMouseDown(coords)),
          onMouseMove: (coords, canvasRect) => dispatch(canvasMouseMove(coords, canvasRect)),
          onMouseUp: (coords) => dispatch(canvasMouseUp(coords)),
          //onMouseEnter: () => dispatch(canvasMouseEnter()),
          canvasSizeUpdated: (width, height) => dispatch(canvasSizeUpdated(width, height))
        }
      }
    };
  }
)(AnnotationCanvas);
export default connectedAnnotationCanvas;
